import { render } from "./EntityDocumentsModal.vue?vue&type=template&id=60b9a3fa&scoped=true"
import script from "./EntityDocumentsModal.vue?vue&type=script&lang=js"
export * from "./EntityDocumentsModal.vue?vue&type=script&lang=js"

import "./EntityDocumentsModal.vue?vue&type=style&index=0&id=60b9a3fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b9a3fa"]])

export default __exports__